import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControlLabel,
  Grid,
  Modal,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import postOnSlack from 'src/core/postOnSlack';
import {
  getTodayDateTimeUTC,
  sendFormSubmissionEmail,
  updateEnterpriseLeadsInGoogleSheet,
  validateEmail,
} from 'src/utils/functions';
import CloseIcon from '@mui/icons-material/Close';
import { COLOR_PRIMARY_1, COLOR_PRIMARY_2, COLOR_TEXT_1, SIDEBAR_COLOR } from 'src/colors';
import { DataGrid } from '@mui/x-data-grid';
import { SCALE_CTA } from 'src/const';

const VrmLeadForm = ({
  user,
  currentMarket,
  setShowVRMLeadForm,
  handleOnSampleClick,
  successAlert,
  matches,
  hostDummyDataRows,
  hostDummyDataColumns,
  showVRMLeadForm,
  postSubmitRedirection,
}) => {
  const [email, setEmail] = useState<string>(user.email == 'Trial' ? '' : user.email);
  const [shareDataPulically, setShareDataPulically] = useState<string>('');
  const [companyName, setCompanyName] = useState<string>('');
  const [market, setMarket] = useState<string>(currentMarket);
  const [additionNote, setAdditionalNote] = useState<string>('');
  const [showSampleDataModal, setShowSampleDataModal] = useState<boolean>(false);
  const [minNoOfAirbnbListings, setMinNoOfAirbnbListings] = useState<string>('');
  const [maxNoOfAirbnbListings, setMaxNoOfAirbnbListings] = useState<string>('');
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [
    needCompanyWebsiteForProfessionalHost,
    setNeedCompanyWebsiteForProfessionalHost,
  ] = useState<string>('');
  const [showEmailNotEnteredWarning, setEmailNotEnteredWarning] = useState<boolean>(false);
  const [showEnterValidEmailWarning, setEnterValidEmailWarning] = useState<boolean>(false);

  const closeVRMLeadFormModal = () => {
    setShowVRMLeadForm(false);
  };

  const handleOnSubmitExportDataClick = async () => {
    if (email === 'Trial' || email === '') {
      setEmailNotEnteredWarning(true);
      setEnterValidEmailWarning(false);
    } else {
      if (validateEmail(email)) {
        setSubmitLoading(true);
        setEmailNotEnteredWarning(false);
        setEnterValidEmailWarning(false);
        let fullUrl = window.location.href;
        let message = `VRM Lead Form Submit\nName: ${user.userName}\nUser: ${email}\nWant to share data publicly: ${shareDataPulically}\nMinimum number of Airbnb listings: ${minNoOfAirbnbListings}\nMaximum number of Airbnb listings: ${maxNoOfAirbnbListings}\nNeed the company websites of professional Airbnb hosts: ${needCompanyWebsiteForProfessionalHost}\nCompany name/Individual use: ${companyName}\nMarket: ${market}\nAdditional notes: ${additionNote}\nMarket URL : ${fullUrl}`;
        let sendSlackMessage = await postOnSlack('C072095QUU9', message);
        let name = user.userName == 'Trial' ? '' : user.userName;
        let emailText = `<b>Hi ${name}</b>, <br><br> This is to confirm that we have received your recent airbnb host data request. Our team will review it promptly, <br> and you can expect a response within 2-3 working days. <br><br> Thanks, <br> Support<br>(Airbtics)`;
        let title = 'Confirmation: Your Airbnb Host Data Export Request (Airbtics) ';
        await sendFormSubmissionEmail(email, emailText, title);
        let todaysDate = getTodayDateTimeUTC();
        await updateEnterpriseLeadsInGoogleSheet(
          'host_data',
          `[${todaysDate}|${name}|${email}|${shareDataPulically}|${minNoOfAirbnbListings}|${maxNoOfAirbnbListings}|${needCompanyWebsiteForProfessionalHost}|${companyName}|${market}|${additionNote}|${fullUrl}]`
        );
        setSubmitLoading(false);
        closeVRMLeadFormModal();
        successAlert('Form submitted successfully');
        setTimeout(() => {
          postSubmitRedirection();
        }, 3000);
      } else {
        setEmailNotEnteredWarning(false);
        setEnterValidEmailWarning(true);
      }
    }
  };

  const SampleVrmDataModal = () => {
    const closeSampleVRMFormModal = () => {
      setShowSampleDataModal(false);
    };
    return (
      <Modal
        open={showSampleDataModal}
        onClose={closeSampleVRMFormModal}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Grid
          container
          item
          sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            position: 'relative',
            width: matches ? '80%' : '60%',
          }}
        >
          <Box sx={{ position: 'absolute', top: '10px', right: '10px' }}>
            <CloseIcon
              sx={{ cursor: 'pointer', color: COLOR_TEXT_1 }}
              onClick={closeSampleVRMFormModal}
            />
          </Box>
          <Grid
            item
            xs={12}
            sx={{
              padding: '30px',
              border: 'none',
              backgroundColor: SIDEBAR_COLOR,
              borderRadius: '10px',
            }}
          >
            <Box sx={{ height: '500px', width: '100%' }}>
              <DataGrid
                sortingOrder={['desc']}
                sx={{ backgroundColor: 'white' }}
                rows={hostDummyDataRows}
                columns={hostDummyDataColumns}
                disableColumnFilter={true}
                disableColumnMenu={true}
              />
            </Box>
          </Grid>
        </Grid>
      </Modal>
    );
  };

  return (
    <Modal
      open={showVRMLeadForm}
      onClose={closeVRMLeadFormModal}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Grid
        container
        item
        // xs={12}
        sx={{
          backgroundColor: 'white',
          borderRadius: '8px',
          maxHeight: matches ? '500px' : '700px',
          position: 'relative',
          width: '40%',
          minWidth: '300px',
        }}
      >
        <SampleVrmDataModal />
        <Grid
          item
          xs={12}
          sx={{
            height: '70px',
            padding: '20px 20px 0px 20px',
            border: 'none',
            color: COLOR_PRIMARY_1,
            fontWeight: 'bold',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant={matches ? 'h6' : 'h5'} sx={{ textAlign: 'center' }}>
            {SCALE_CTA} to unlock this feature today!
          </Typography>
          <CloseIcon
            sx={{ cursor: 'pointer', color: COLOR_PRIMARY_1 }}
            onClick={closeVRMLeadFormModal}
          />
        </Grid>
        <Grid
          container
          item
          xs={12}
          sx={{
            maxHeight: matches
              ? '330px'
              : showEmailNotEnteredWarning || showEnterValidEmailWarning
              ? '460px'
              : '530px',
            overflow: 'auto',
          }}
        >
          <Grid
            container
            item
            xs={12}
            sx={{
              padding: '20px 40px',
            }}
          >
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Email:
              </Typography>
              <TextField
                id="outlined-basic"
                label=""
                variant="outlined"
                fullWidth
                value={email}
                onChange={e => {
                  setEmail(e.target.value);
                }}
                sx={{
                  '& .MuiOutlinedInput-input': {
                    padding: '10px',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: '15px' }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Do you need to share this data publicly?
              </Typography>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={shareDataPulically}
                onChange={e => {
                  setShareDataPulically(e.target.value);
                }}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid>
            <Grid item xs={12} sx={{ marginTop: '15px' }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Minimum number of Airbnb listings
              </Typography>
              <TextField
                id="outlined-basic"
                label=""
                variant="outlined"
                fullWidth
                value={minNoOfAirbnbListings}
                onChange={e => {
                  setMinNoOfAirbnbListings(e.target.value);
                }}
                sx={{
                  '& .MuiOutlinedInput-input': {
                    padding: '10px',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: '15px' }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Maximum number of Airbnb listings
              </Typography>
              <TextField
                id="outlined-basic"
                label=""
                variant="outlined"
                fullWidth
                value={maxNoOfAirbnbListings}
                onChange={e => {
                  setMaxNoOfAirbnbListings(e.target.value);
                }}
                sx={{
                  '& .MuiOutlinedInput-input': {
                    padding: '10px',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: '15px' }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Do you need the company websites of professional Airbnb hosts? (Will incur extra $1
                per website)
              </Typography>
              <TextField
                id="outlined-basic"
                label=""
                variant="outlined"
                fullWidth
                value={needCompanyWebsiteForProfessionalHost}
                onChange={e => {
                  setNeedCompanyWebsiteForProfessionalHost(e.target.value);
                }}
                sx={{
                  '& .MuiOutlinedInput-input': {
                    padding: '10px',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: '15px' }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                What is your company name? or is this for individual use?
              </Typography>
              <TextField
                id="outlined-basic"
                label=""
                variant="outlined"
                fullWidth
                value={companyName}
                onChange={e => {
                  setCompanyName(e.target.value);
                }}
                sx={{
                  '& .MuiOutlinedInput-input': {
                    padding: '10px',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: '15px' }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Markets (Write countries if you need nationwide data)
              </Typography>
              <TextField
                id="outlined-basic"
                label=""
                variant="outlined"
                fullWidth
                value={market}
                onChange={e => {
                  setMarket(e.target.value);
                }}
                sx={{
                  '& .MuiOutlinedInput-input': {
                    padding: '10px',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: '15px' }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Any Other Notes?
              </Typography>
              <TextField
                id="outlined-multiline-static"
                label=""
                variant="outlined"
                fullWidth
                multiline
                value={additionNote}
                onChange={e => {
                  setAdditionalNote(e.target.value);
                }}
                rows={2}
              />
            </Grid>
            {/* <Grid item xs={12} sx={{ marginTop: '15px' }}>
              <Button
                sx={{
                  width: '100%',
                  backgroundColor: COLOR_PRIMARY_2,
                  color: SIDEBAR_COLOR,
                  '&:hover': { backgroundColor: COLOR_PRIMARY_2, color: SIDEBAR_COLOR },
                  borderRadius: '10px',
                }}
                onClick={() => {
                  setShowSampleDataModal(true);
                }}
              >
                See Demo Data
              </Button>
            </Grid> */}
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            height: showEmailNotEnteredWarning || showEnterValidEmailWarning ? '110px' : '60px',
            padding: '10px',
          }}
        >
          <Button
            sx={{
              width: '100%',
              backgroundColor: COLOR_PRIMARY_1,
              color: SIDEBAR_COLOR,
              borderRadius: '10px',
              '&:hover': { backgroundColor: COLOR_PRIMARY_1, color: SIDEBAR_COLOR },
            }}
            onClick={handleOnSubmitExportDataClick}
          >
            Get in Touch{' '}
            {submitLoading && (
              <CircularProgress sx={{ color: 'white', marginLeft: '4px' }} size={30} />
            )}
          </Button>
          {showEmailNotEnteredWarning && (
            <Box sx={{ margin: '10px 0px' }}>
              <Alert severity="warning" sx={{ padding: '0px 5px' }}>
                Please enter your email ID.
              </Alert>
            </Box>
          )}
          {showEnterValidEmailWarning && (
            <Box sx={{ margin: '10px 0px' }}>
              <Alert severity="error" sx={{ padding: '0px 5px' }}>
                Please enter a valid email ID.
              </Alert>
            </Box>
          )}
        </Grid>
      </Grid>
    </Modal>
  );
};

export default VrmLeadForm;
